export default {
  en: {
    'bundles-polish-sku-components.polish-sku-list.sku-number.heading': 'SKU/Product Code',
    'bundles-polish-sku-components.polish-sku-list.specification.heading':
      'Goods or Service specification',
    'bundles-polish-sku-components.polish-sku-list.specification.tele':
      'Telecommunications, broadcasting & electronic services(EE)',
    'bundles-polish-sku-components.polish-sku-list-item.tele.true': 'Yes',
    'bundles-polish-sku-components.polish-sku-list-item.tele.false': 'No',
  },
};
